// removed by extract-text-webpack-plugin
module.exports = {"container":"_2bGmw9kBBfaEGC5KyQAa78","text":"_1kVet3eNizew2gYn1OD_yG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultsContainer/FinalText/styles.css
// module id = 400
// module chunks = 0